import React, { SVGProps } from 'react'
export function RestoreIcon(props: SVGProps<SVGSVGElement>) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M11 16h2v-4.15l1.6 1.55L16 12l-4-4l-4 4l1.4 1.4l1.6-1.55Zm-6 5V6H4V4h5V3h6v1h5v2h-1v15Zm2-2h10V6H7ZM7 6v13Z"></path></svg>
    )
  }